/**
 * 학습 화면에서 일어나는 사용자 행동(문항 열람·답 변경·그만풀기 등)을 감사 로그로 서버에 보낸다.
 *
 * `src/components/common/AuditLogSync.tsx` 가 큐에 쌓인 이벤트를 꺼내 이 함수로 보낸다.
 * 로그인한 학생의 행동만 기록하면 되므로 `axiosInstance` 를 쓴다.
 *
 * 주의: 이 파일은 `pages/api/` 안에 있지만 서버에서 도는 코드가 아니다.
 * 정적 내보내기라 서버가 없고, 브라우저에서 그냥 불리는 모듈이다.
 */
import { AuditLogPayload } from "@/types/auditLogProps";
import api from "../axiosInstance";

/**
 * 감사 로그 한 건을 보낸다. 실패해도 예외를 던지지 않는다(시험 진행을 막으면 안 되기 때문).
 *
 * payload.kind 판별자로 전송 경로를 분기한다.
 *   - "essay" → POST /app/logs/essay-audit (essayChapterId + ESSAY_* eventType)
 *   - 그 외   → POST /app/logs/audit       (객관식, chapterId)
 * essay payload 는 BE EssayChapterAuditLogRequest 에 맞춰 essayChapterId/eventType/
 * eventAt/metadata 만 보낸다(kind·chapterId 는 클라이언트 내부 판별용이라 제외).
 */
export const postAuditLog = async (payload: AuditLogPayload): Promise<void> => {
  try {
    if (payload.kind === "essay") {
      await api.post("/app/logs/essay-audit", {
        essayChapterId: payload.essayChapterId,
        eventType: payload.eventType,
        eventAt: payload.eventAt,
        metadata: payload.metadata,
      });
      return;
    }
    await api.post("/app/logs/audit", payload);
  } catch (error) {
    // 로그 실패는 무시. 시험 진행에 영향을 주면 안 됨.
    console.warn("[AuditLog] 전송 실패:", error);
  }
};
